import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Image } from 'react-bootstrap';
import { translate } from 'react-i18next';

import { GOOGLE_MAPS_ZOOM } from '../../util/constants';
import brandImage from '../../images/brand-logo.png';

const UnitMap = ({ unit, t }) => {
  const [mapReady, setMapReady] = useState(false);
  const [geocodeError, setGeocodeError] = useState(false);

  const initMap = () => {
    const mapElement = document.getElementById('google-map');
    if (!mapElement) {
      console.error('Map element not found');
      return;
    }
    /* global google */
    const map = new google.maps.Map(mapElement, {
      zoom: GOOGLE_MAPS_ZOOM,
      scrollwheel: false
    });
    const geocoder = new google.maps.Geocoder();

    const address = `${unit.address}, ${unit.city}`;
    geocoder.geocode({ address }, (results, status) => {
      if (status === 'OK') {
        map.setCenter(results[0].geometry.location);
        setMapReady(true);
      } else {
        setGeocodeError(true);
      }
    });
  };

  useEffect(() => {
    initMap();
  }, [unit]);

  const mapElement = (
    <div id="google-map" className={`unit-google-map ${mapReady ? 'loaded' : ''}`} />
  );

  const unitImage = (
    <div className={`unit-image ${geocodeError || !mapReady ? 'loaded' : ''}`}>
      <Image alt={t('common:ariaLabels.brandImage')} src={brandImage} />
    </div>
  );

  return (<div style={{ width: '100%', height: '100%' }}>
    {(!geocodeError || mapReady) && mapElement}
    {(geocodeError && !mapReady) && unitImage}
  </div>);
};

UnitMap.propTypes = {
  unit: PropTypes.shape({}).isRequired,
  t: PropTypes.func.isRequired
};

export default translate(() => ['common', 'booking'])(UnitMap);



// WEBPACK FOOTER //
// ./src/containers/UnitMap/UnitMap.jsx